<template>
  <div>
    <template v-for="(a, index) in actions">
      <template v-if="a.show === undefined || resolveFn(a.show)">
        <b-button
          :size="a.size || 'sm'"
          :variant="a.variant || 'link'"
          :class="a.buttonClass || 'pl-0'"
          :disabled="a.disabled !== undefined && resolveFn(a.disabled)"
          v-b-tooltip.hover
          :title="a.tooltip"
          @click="a.exec()">
          <i v-if="a.icon" :class="'fa fa-fw fa-' + a.icon"></i>
          {{ a.label }}
        </b-button>
      </template>
    </template>
  </div>
</template>
<script>
import BaseColumnRendererMixin from 'vue-cl/renderers/column/BaseColumnRendererMixin';

export default {
  mixins: [ BaseColumnRendererMixin ],

  computed: {
    actions() {
      const col = this.col;

      if (col.actions === undefined) {
        throw Error("Bad column: missing 'actions': " + JSON.stringify(col));
      }

      return this.resolveFn(col.actions, this.item, this.index);
    }
  }
};
</script>
